import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'

import en from '@/langs/en'
import tw from '@/langs/zh-tw'

Vue.use(VueI18n)
Vue.use(VueLocalStorage)

let messages = {}

messages = { ...messages, en, tw }

const i18n = new VueI18n({
  locale: 'tw',
  messages
})

i18n.locale = Vue.localStorage.get('ui-lang', 'tw')

export default i18n